// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
    dsn: 'https://0315c06fbd134be8af424a54041a7040@sentry.io/1353514',
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1.0,
    enabled: process.env.NODE_ENV === 'production',
    release: process.env.SENTRY_RELEASE,
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
});
